import React from "react";
import { Text, View } from "react-native";

import t from "@constants/localization";

const PATH = "components/LGL/TnC";

const TnC = ({ tnc }) => (
  <View
    style={{
      backgroundColor: "white",
      borderRadius: 10,
      paddingHorizontal: 15,
      paddingVertical: 20,
      marginTop: 10,
      elevation: 1,
    }}
  >
    <Text
      style={{
        fontFamily: "NotoSansDevanagari-Regular",
        fontSize: 16,
      }}
    >
      {t(`${PATH}/TnC`)}
    </Text>
    <View style={{ marginTop: 10 }}>{renderTnc(tnc)}</View>
  </View>
);

const renderTnc = (text = "") => {
  return text
    .split("\\n")
    .map((item) => item.trim())
    .map((item) =>
      item.startsWith("*") ? (
        <View style={{ flexDirection: "row" }} key={item}>
          <View>
            <Text
              bold
              style={{ fontSize: 12, fontFamily: "NotoSansDevanagari-Bold" }}
            >
              {"\u2022"}
            </Text>
          </View>
          <View
            style={{
              flex: 1,
              marginLeft: 5,
              marginBottom: 5,
            }}
          >
            <Text
              style={{
                fontSize: 14,
                lineHeight: 20,
                fontFamily: "NotoSansDevanagari-Regular",
              }}
            >
              {item.slice(1).trim()}
            </Text>
          </View>
        </View>
      ) : (
        <Text
          key={item}
          style={{
            fontSize: 14,
            lineHeight: 20,
            marginBottom: 3,
          }}
        >
          {item.trim()}
        </Text>
      ),
    );
};

export default TnC;
